import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import {useBrand} from "../../component/BrandProvider";
import {useParams} from "react-router";

export const useGetRetailWashMix = (body: any) => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/Revenue/Retail-Wash-Breakdown/${body["start_date"]}/${body["end_date"]}${body["plans"] === undefined ? "" : `/${body["plans"].join(",")}`}${body["sites"] === undefined ? "" : `/${body["sites"].join(",")}`}`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["Free-Washes", body["start_date"], body["end_date"], brand, url, body["plans"], body["sites"]],
		queryFn: queryFn,
		gcTime: 59 * 60 * 1000,
		refetchOnWindowFocus: false,
		staleTime: 60 * 60 * 1000,
	});
};

export const useGetHourlyRevenue = (body: any) => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/Revenue/Hourly-Count/${body["wash_type"]}/${body["start_date"]}/${body["end_date"]}${body["sites"] === undefined ? "" : `/${body["sites"].join(",")}`}`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["Free-Washes", body["start_date"], body["end_date"], body["wash_type"], url, brand, body["sites"], body["plans"]],
		queryFn: queryFn,
		gcTime: 59 * 60 * 1000,
		refetchOnWindowFocus: false,
		staleTime: 60 * 60 * 1000,
	});
};

export const useGetFreeWashes = (body: any) => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/Revenue/Free-Washes/${body["start_date"]}/${body["end_date"]}${body["sites"] === undefined ? "" : `/${body["sites"].join(",")}`}`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["Free-Washes", body["start_date"], body["end_date"], url, brand, body["sites"]],
		queryFn: queryFn,
		refetchOnWindowFocus: false,
		staleTime: 60 * 60 * 1000,
		gcTime: 59 * 60 * 1000,
	});
};

export const useGetArmRevenueByPackage = (body: any) => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/Revenue/ARM-Revenue/Package/${body["start_date"]}/${body["end_date"]}/${body["plans"]}${body["sites"] === undefined ? "" : `/${body["sites"].join(",")}`}`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["Arm-Revenue-Package", url, brand, body["start_date"], body["end_date"], body["plans"], body["sites"]],
		queryFn: queryFn,
		refetchOnWindowFocus: false,
		staleTime: 60 * 60 * 1000,
		gcTime: 59 * 60 * 1000
	});
};

export const useGetArmRevenue = (body: any) => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/Revenue/ARM-Revenue/${body["start_date"]}/${body["end_date"]}${body["sites"] === undefined ? "" : `/${body["sites"].join(",")}`}`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["Arm-Revenue", url, brand, body["start_date"], body["end_date"], body["sites"]],
		queryFn: queryFn,
		refetchOnWindowFocus: false,
		staleTime: 60 * 60 * 1000,
		gcTime: 59 * 60 * 1000
	});
};

export const useGetArmRevenueFYTD = (body?: any) => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/Revenue/ARM-Revenue-FYTD`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["Arm-Revenue", "FYTD", url, brand],
		queryFn: queryFn,
		refetchOnWindowFocus: false,
		staleTime: 60 * 60 * 1000,
		gcTime: 59 * 60 * 1000
	});
};

export const useGetArmRevenuePTD = (body?: any) => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/Revenue/ARM-Revenue-PTD`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["Arm-Revenue", "PTD", url, brand],
		queryFn: queryFn,
		refetchOnWindowFocus: false,
		staleTime: 60 * 60 * 1000,
		gcTime: 59 * 60 * 1000
	});
};

export const useGetArmRevenueWTD = (body?: any) => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/Revenue/ARM-Revenue-WTD`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["Arm-Revenue", "WTD", url, brand],
		queryFn: queryFn,
		refetchOnWindowFocus: false,
		staleTime: 60 * 60 * 1000,
		gcTime: 59 * 60 * 1000
	});
};

export const useGetWashRevenuePackage = (body: any) => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/Revenue/Wash-Revenue/Package/${body["start_date"]}/${body["end_date"]}/${body["plans"]}${body["sites"] === undefined ? "" : `/${body["sites"].join(",")}`}`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["Wash-Revenue-Package", url, brand, body["start_date"], body["end_date"], body["sites"], body["plans"]],
		queryFn: queryFn,
		refetchOnWindowFocus: false,
		staleTime: 60 * 60 * 1000,
		gcTime: 59 * 60 * 1000
	});
};

export const useGetWashRevenue = (body: any) => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/Revenue/Wash-Revenue/${body["start_date"]}/${body["end_date"]}${body["sites"] === undefined ? "" : `/${body["sites"].join(",")}`}`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["Wash-Revenue", url, brand, body["sites"], body["start_date"], body["end_date"]],
		queryFn: queryFn,
		refetchOnWindowFocus: false,
		staleTime: 60 * 60 * 1000,
		gcTime: 59 * 60 * 1000
	});
};

export const useGetWashRevenueWTD = () => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/Revenue/Wash-Revenue-WTD`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["Wash-Revenue", url, brand, 'WTD'],
		queryFn: queryFn,
		refetchOnWindowFocus: false,
		staleTime: 60 * 60 * 1000,
		gcTime: 59 * 60 * 1000
	});
};

export const useGetWashRevenuePTD = () => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/Revenue/Wash-Revenue-PTD`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["Wash-Revenue", url, brand, 'PTD'],
		queryFn: queryFn,
		refetchOnWindowFocus: false,
		staleTime: 60 * 60 * 1000,
		gcTime: 59 * 60 * 1000
	});
};

export const useGetWashRevenueFYTD = () => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/Revenue/Wash-Revenue-FYTD`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["Wash-Revenue", url, brand, 'FYTD'],
		queryFn: queryFn,
		refetchOnWindowFocus: false,
		staleTime: 60 * 60 * 1000,
		gcTime: 59 * 60 * 1000
	});
};